import styled from "styled-components";


export const OpenIdeaCountColumn = styled.div`
    display: flex;
    flex-direction: column;
    text-transform: none;
    font-size: 11px;
`;

export const OpenIdeaCountCell = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    font-size: 11px;
`;
